import { render, staticRenderFns } from "./MySupporters.vue?vue&type=template&id=97d6a4e8&scoped=true&"
import script from "./MySupporters.vue?vue&type=script&lang=js&"
export * from "./MySupporters.vue?vue&type=script&lang=js&"
import style0 from "./MySupporters.vue?vue&type=style&index=0&id=97d6a4e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d6a4e8",
  null
  
)

export default component.exports